module.exports = __webpack_public_path__ + "static/media/msmode.3acebff9.png";